import { Card } from 'components/ui/card';
import { memo, PropsWithChildren } from 'react';

interface AccordionProps {
  className?: string;
}

function Accordion(props: PropsWithChildren<AccordionProps>) {
  const { className = '', children } = props;

  return <Card className={className}>{children}</Card>;
}

export default memo(Accordion);
